import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import 'react-table-6/react-table.css';
import ExportableTable from 'containers/tables/ExportableTable';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import CellDiv from 'components/molecules/tables/components/CellDiv';
import RenderingTile from 'components/molecules/RenderingTile';
import helpers from 'helpers';
import Pagination, { RowsPerPageDefault } from 'components/molecules/tables/components/Pagination';
import { generateFooterData, generateHeaders } from 'helpers/tables';
import { insertBeforeItem } from 'helpers/utilities';

const DEFAULT_ACCESSORS = [
    'impressions', 'videoViews', 'videoViewRate', 'cpvv', 'conversions', 'clicks', 'ctr', 'cpc'
];

class YoutubeCreativePerformanceTable extends Component {
    constructor(props) {
        super(props);

        let columns;
        let data;

        if (props.hasData) {
            const table = YoutubeCreativePerformanceTable.createTableData(props.data, props);
            columns = table.columns;
            data = table.data;
        }
        this.state = {
            data,
            columns,
            hasData: props.hasData,
            exportName: props.exportName
        };
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    static createTableData(data, props) {
        const headers = generateHeaders({
            keys: [
                'impressions', 'videoViews', 'videoViewRate', 'cpvv',
                'conversions', 'conversion_revenue', 'clicks', 'ctr', 'cpc',
            ],
            colOptions: {
                labelCode: props.entityObjectiveLabelCode
            },
            footerData: generateFooterData({
                data,
                filteredKeys: ['video_title', 'video_id']
            }),
            initial: {
                videoTitle: {
                    Header: 'TITLE',
                    accessor: 'video_title',
                    minWidth: 250,
                    Cell: row => <CellDiv value={row.value} />,
                    Footer: (
                        <CellDiv value='Total' strong />
                    )
                }
            }
        });

        const defaultAccessors = [].concat('videoTitle', DEFAULT_ACCESSORS);

        let { accessors = defaultAccessors } = props;
        if (props.showConversionRevenue && !accessors.includes('conversion_revenue')) {
            accessors = insertBeforeItem(accessors, 'clicks', 'conversion_revenue');
        }
        const columns = accessors.map(accessor => headers[accessor]);
        return { data, columns };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextData = nextProps.data;
        const nextExportName = nextProps.exportName;
        const nextHasData = nextProps.hasData;
        let nextState = null;

        if (!isEqual(nextData, prevState.data)) {
            let columns;
            let data;


            if (nextHasData) {
                const table = YoutubeCreativePerformanceTable.createTableData(nextData, nextProps);
                columns = table.columns;
                data = table.data;
            }
            nextState = {
                ...prevState,
                columns,
                data,
                exportName: nextExportName,
                hasData: nextHasData,
            };
        }
        return nextState;
    }

    render() {
        const { data, exportName, columns, hasData, uniqueCreatives } = this.state;
        const expanded = uniqueCreatives > 1 ? undefined : { 0: true };

        return hasData ? (
            <ContentTile padding={helpers.contentPadding('table')}>
                <ContentHeader tableData={data} exportName={exportName} type={'table'}>CREATIVE PERFORMANCE</ContentHeader>
                <ExportableTable
                    key={1}
                    title="CREATIVE PERFORMANCE"
                    exportName={exportName}
                    data={data}
                    columns={columns}
                    expanded={expanded}
                    getTheadThProps={() => ({ style: { outline: 0 } })}
                    getTfootProps={() => ({ style: { backgroundColor: '#E2E2E2', fontWeight: 'bold', boxShadow: 'none' } })}
                    defaultSorted={[
                        { id: 'video_title', desc: false },
                    ]}
                    showPagination={data && data.length > RowsPerPageDefault}
                    PaginationComponent={Pagination}
                    defaultPageSize={RowsPerPageDefault}
                    exportRows={data.length}
                    minRows={data && data.length < RowsPerPageDefault ? data.length : RowsPerPageDefault}
                    className="-highlight"
                />
            </ContentTile>
        ) : (
            <RenderingTile height='400px' />
        );
    }
}

YoutubeCreativePerformanceTable.propTypes = {
    exportName: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        campaign_name: PropTypes.string,
        adgroup_name: PropTypes.string,
        video_title: PropTypes.string
    })),
    accessors: PropTypes.arrayOf(PropTypes.string),
    hasData: PropTypes.bool.isRequired,
    tableType: PropTypes.string,
};

export default YoutubeCreativePerformanceTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/YoutubeCreativePerformanceTable.js